import Api from './Api';

class Subscription extends Api {
  createSubscription(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('/v1/zuora/subscribe/web', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.body && error.body.error ? error.body.error : error);
      });
    });
  }

  fetchSubscriptionPlans(currencyCode) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/zuora/products', { product_type: 'WebStore', currency: currencyCode }).then((resp) => {
        let plan = null;
        if (resp && resp.success && resp.products.length) {
          const product = resp.products[0];
          [plan] = product.productRatePlans;
        }
        resolve(plan);
      }).catch((error) => {
        reject(error && error.body && error.body.error ? error.body.error : error);
      });
    });
  }

  getSubscription() {
    return new Promise((resolve, reject) => {
      super.getList('/v1/zuora/subscription', {}).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.body && error.body.error ? error.body.error : error);
      });
    });
  }

  cancelSubscription() {
    return new Promise((resolve, reject) => {
      super.post('/v1/zuora/unsubscribe').then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error.body.error || error);
      });
    });
  }

  updatePaymentInfo(paymentOpts) {
    return new Promise((resolve, reject) => {
      super.post('/v1/zuora/payment/credit-card', paymentOpts).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error && error.body && error.body.error ? error.body.error : error);
      });
    });
  }

  fetchTransactionHistory(params) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/user/transactions', params).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error.body.error);
      });
    });
  }

  validateAndStorePromoCode(promoCode, currency) {
    return new Promise((resolve, reject) => {
      const { activePlan } = window.$store.getters;
      super.get('/v1/zuora/promo/{promo_code}/validate', { promo_code: promoCode, productRatePlans: activePlan && activePlan.id ? activePlan.id : '', currency }).then((resp) => {
        resolve(resp);
        if (resp && resp.valid) {
          localStorage.setItem('promo_code', promoCode);
          if (resp.promoData && resp.promoData.ratePlan) {
            const plan = resp.promoData.ratePlan[0];
            if (plan && plan.id) {
              const currentDate = new Date();
              currentDate.setMonth(currentDate.getMonth() + parseInt(plan.upToPeriods, 10));
              localStorage.setItem('promo_trial_end_date', currentDate);
              localStorage.setItem('promo_trial_period', parseInt(plan.upToPeriods, 10));
              const { promoData } = window.$store.getters;
              promoData.promoCode = promoCode;
              promoData.trialPeriod = parseInt(plan.upToPeriods, 10);
              promoData.trialEndDate = currentDate;
              window.$store.dispatch('setPromoData', promoData);
            }
          }
        }
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getTransactionDetails(transactionId) {
    return new Promise((resolve, reject) => {
      super.get('/v1/user/transactions-details/{transaction_id}', { transaction_id: transactionId }).then((resp) => {
        if (resp) {
          resolve(resp);
        }
      }).catch((error) => {
        reject(error);
      });
    });
  }
}

export default Subscription;



// WEBPACK FOOTER //
// ./app/src/services/Subscription.js